// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrademarkOutlinedSvg from "@fishx/icons-svg/es/asn/TrademarkOutlined";
import FishxIcon from '../components/FishxIcon';

var TrademarkOutlined = function TrademarkOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkOutlinedSvg
  }));
};

TrademarkOutlined.displayName = 'TrademarkOutlined';
export default React.forwardRef(TrademarkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TrademarkOutlined.js
// module id = 4282
// module chunks = 0